import clsx from 'clsx'
import React from 'react'
import ToolTip from './tool-tip'

interface ICustomInput extends React.InputHTMLAttributes<HTMLInputElement> {
    className?: string
    label?: string
    tooltip?: string
}

const CustomInput: React.FC<ICustomInput> = ({ className, label, tooltip, ...props }) => {
    return (
        <div className='w-full flex flex-col'>
            {label && <label htmlFor={props.id || props.name} className='flex items-center justify-start gap-2 font-bold text-white text-[15px] w-full'>{label} {tooltip && <ToolTip />} </label>}
            <input id={props.id || props.name} {...props} className={clsx("w-full h-[52px] mt-2 px-4 rounded-xl bg-app-field border border-white/[0.12] font-semibold text-white text-[16px] tracking-wide outline-none transition-[border-color,box-shadow] duration-200 placeholder:text-white/[0.55] placeholder:font-medium hover:border-white/[0.22] focus:border-brand-accent focus:shadow-focus focus-visible:outline-none", className)} />
        </div>
    )
}

export default CustomInput
